import { ShareButtonNext } from 'components/common-form/sidePanel/docToolbar/summary';
import { PriceNext, QuoteStatus, ReadyIcon } from 'components/shared/PriceNext';
import { FC, PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import { connectReady, ReadyState } from './Ready.status.connect';

export const Component: FC<PropsWithChildren<ReadyState>> = ({ workspaceType, tabId, solvingMode }) => {
  const isDynamicWorkspace = workspaceType === 'dynamic';

  return (
    <PriceNext
      className="border"
      solveMode={
        <SolveModeLabel workspaceType={workspaceType} solvingMode={solvingMode} isMultipleSolvingMode={false} />
      }
      shareButton={!isDynamicWorkspace && <ShareButtonNext className="text-primary" tabId={tabId} />}
      quoteStatus={<QuoteStatus icon={<ReadyIcon />} description="sidePanel.quoteStatus.readyToQuote" />}
    />
  );
};

export const ReadyComponent = connectReady(Component);

Component.displayName = 'Ready';
